import styled from 'styled-components';
import { Sidebar } from 'react-admin';

const CustomSidebar = styled(Sidebar)`
  padding: 0 5px;
  & a {
    font-size: 14px;
    border: 2px solid transparent;
    border-style: outset;
    border-radius: 5px;
  }
  & a[aria-current*='page'] {
    border: 2px solid ${({ theme: { palette } }) => palette.primary.ligth};
    font-size: 14px;
    border-style: outset;
    border-radius: 5px;
    font-weight: bold;
    padding-left: 14px;
    & > div {
      color: ${({ theme: { palette } }) => palette.primary.ligth};
    }
  }
`;

export default CustomSidebar;
